import slugify from "slugify";
import { collectionGroupItemIcons } from "./CollectionBlockTypes";
export const collectionBlock = (p)=>({
        kind: "collection",
        title: p.field_title,
        introduction: p.field_rich_text,
        displayQuickLinks: p.field_display_quick_links === true || p.field_display_quick_links === null,
        collectionGroups: p.field_collection_groups.map((group)=>({
                title: group.field_title,
                slug: slugify(group.field_title),
                collectionItems: group.field_collection_items.map((item)=>({
                        title: item.field_title,
                        subtitle: item.field_subtitle,
                        text: item.field_text,
                        link: item.field_link.url,
                        icon: collectionGroupItemIcons.find((v)=>v === item.field_icon) || "none"
                    })).toArray()
            })).toArray()
    });
